/**
 * @generated SignedSource<<0b3e3b01fa6d0e267a46067caa17828e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GeoFundableCases_item$data = {
  readonly caseCard: {
    readonly rendered: string | null;
  } | null;
  readonly " $fragmentType": "GeoFundableCases_item";
};
export type GeoFundableCases_item$key = {
  readonly " $data"?: GeoFundableCases_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"GeoFundableCases_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GeoFundableCases_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CaseCard",
      "kind": "LinkedField",
      "name": "caseCard",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rendered",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CaseArticle",
  "abstractKey": null
};

(node as any).hash = "7fbcc6fa08e826380caaf2c0f4b8f99c";

export default node;
